module.exports = __webpack_public_path__ + "static/media/back.699363bb.svg";